var AuthModal = ( function($) {

    var AuthModal = function(options) {
        this.init(options);
    };

    var Self = AuthModal;
    Self.className = 'AuthModal';
    var Parent = ActionformModalAbstract;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.classes = {
            auth_modal: 'auth-modal'
        };

        that.modal_options = {
            onBgClick: function () {
                return false;
            }
        };

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.onOpen = function ($modal_wrapper, modal) {
        var that = this;

        Parent.prototype.onOpen.call(that, $modal_wrapper, modal);

        $modal_wrapper.addClass(that.classes.auth_modal);
    };

    return Self;

})($);